<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content *ngIf="composition" [noPadding]="true">
  <mat-tab-group>
    <mat-tab label="1. Screen">
      <composition-wizard-screen [composition]="composition" (organisationSet)="organisationId = $event" [isCopy]="isCopy"
                                 [orgCustomers]="orgCustomers" (customerSet)="customerId = $event"
                                 [organisations]="organisations"></composition-wizard-screen>
    </mat-tab>
    <mat-tab label="2. Imports"><composition-wizard-imports [composition]="composition"></composition-wizard-imports></mat-tab>
    <mat-tab label="3. Dynamic Content Entrances">
      <composition-wizard-dynamic-entrance [composition]="composition"></composition-wizard-dynamic-entrance>
    </mat-tab>
    <mat-tab label="4. Snippets"><composition-wizard-code-snippets [composition]="composition"></composition-wizard-code-snippets></mat-tab>
  </mat-tab-group>

  <div class="save-container"><button (click)="saveComposition()" class="ibexfusion-raised-button" mat-button>Save</button></div>
</page-content>
